/** UI locales; assistant/backend language contracts are independent. */
export const localeDefinitions = {
  en: { creditUnit: 'DOBI coins', name: 'English', flag: '🇺🇸', html: 'en', openGraph: 'en_US' },
  zh: { creditUnit: 'DOBI币', name: '简体中文', flag: '🇨🇳', html: 'zh-CN', openGraph: 'zh_CN' },
  ja: { creditUnit: 'DOBI コイン', name: '日本語', flag: '🇯🇵', html: 'ja', openGraph: 'ja_JP' },
  ko: { creditUnit: 'DOBI 코인', name: '한국어', flag: '🇰🇷', html: 'ko', openGraph: 'ko_KR' },
  th: { creditUnit: 'เหรียญ DOBI', name: 'ไทย', flag: '🇹🇭', html: 'th', openGraph: 'th_TH' },
  fr: { creditUnit: 'pièces DOBI', name: 'Français', flag: '🇫🇷', html: 'fr', openGraph: 'fr_FR' },
  de: { creditUnit: 'DOBI Coins', name: 'Deutsch', flag: '🇩🇪', html: 'de', openGraph: 'de_DE' },
  it: { creditUnit: 'monete DOBI', name: 'Italiano', flag: '🇮🇹', html: 'it', openGraph: 'it_IT' },
} as const;
export type Locale = keyof typeof localeDefinitions;
export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(localeDefinitions, value);
}
export function normalizeLocale(value: unknown): Locale {
  const language = typeof value === 'string' ? value.split('-')[0] : '';
  return isLocale(language) ? language : 'en';
}

/** Persist an explicit choice, keeping the current route, query and fragment. */
export function selectLocale(locale: Locale): string {
  document.cookie = `NEXT_LOCALE=${locale}; path=/; max-age=31536000; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`;
  const url = new URL(window.location.href);
  if (locale === 'en') url.searchParams.delete('lang');
  else url.searchParams.set('lang', locale);
  return `${url.pathname}${url.search}${url.hash}`;
}
